import fetch from '@giro/shared-utils/fetch.util';

export default async function deleteApiUserkeysIdService(id) {
  return fetch(`userkeys/${id}`, {
    method: 'DELETE',
    ms: 'PDV',
    auth: true,
  });
}
